import routes from 'app/history/routes';

export default {
  routes,
};
